module.exports = __webpack_public_path__ + "img/sort-descending-icons.5fc179a9.svg";